import { Button } from "@/components/ui/button";
import { ArrowUpRight } from "lucide-react";

export default function FinalCTA() {
  return (
    <section
      data-testid="final-cta-section"
      className="bg-[#182649] py-24 lg:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8 text-center">
        <h2
          className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white tracking-tight leading-[1.1] uppercase"
          style={{ fontFamily: "Outfit, sans-serif" }}
          data-testid="final-cta-headline"
        >
          Secure your <span className="text-[#D49A38]">presence</span> in Jamaica
        </h2>

        <div className="mt-10">
          <Button
            asChild
            className="bg-[#D49A38] text-white hover:bg-[#c08a2e] rounded-full px-10 py-6 text-base font-semibold transition-all duration-300 shadow-lg"
            data-testid="final-cta-button"
          >
            <a href="https://1141bc.com" target="_blank" rel="noopener noreferrer">
              Explore Eleven 41
              <ArrowUpRight className="ml-2 h-4 w-4" />
            </a>
          </Button>
        </div>
      </div>
    </section>
  );
}
